export enum assetAlignment {
  trailing_asset = "trailing_asset",
  leading_asset = "leading_asset",
}
